import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import siteCoreApiInstance from "../../instances/siteCoreApiInstance";
import { API_ENDPOINTS } from "../../../helpers/constants";
import {
  PageContentApiP1Response,
  PageContentApiResponse,
  ReferenceServiceApiParams,
  ReferenceServiceApiResponse,
} from "./models";
import { userPreferredLanguageSelector } from "../../../redux/slices/appState/appStateSelector";
import siteCoreApiP1Instance from "../../instances/siteCoreApiInstanceP1";

export const useGetPageContentMutation = () => {
  const preferredLanguage = useSelector(userPreferredLanguageSelector);
  return useMutation<PageContentApiResponse, unknown, string>({
    mutationFn: async (params: string) => {
      const response = await siteCoreApiInstance.post<PageContentApiResponse>(
        API_ENDPOINTS.SITE_CORE_API,
        {
          categoryname: "Default",
          pagename: params,
          language: preferredLanguage,
          sitename: "cirrusadmin",
        },
      );
      return response?.data ?? null;
    },
    retry: false,
  });
};

//this is used for getting the value of dropdown based on selected language
export const useGetSiteCoreReferenceDataValueByKey = () => {
  const preferredLanguage = useSelector(userPreferredLanguageSelector);
  return useMutation<
    ReferenceServiceApiResponse[],
    unknown,
    ReferenceServiceApiParams
  >({
    mutationFn: async (params: ReferenceServiceApiParams) => {
      const response = await siteCoreApiInstance.post<
        ReferenceServiceApiResponse[]
      >(API_ENDPOINTS.SITE_CORE_REFERENCE_API, {
        categoryname: "Default",
        ReferenceDataType: params.referenceDataType, //dropdown key
        keys: params.keys, // dropdown options keys
        language: preferredLanguage,
        sitename: "cirrusadmin",
      });
      return response?.data ?? null;
    },
    retry: false,
  });
};

export interface GetPageContentParams {
  PageName: string;
  MarketName: string;
  language?: string;
  Persona: string;
}

export const useGetPageP1ContentMutation = () => {
  return useMutation<PageContentApiP1Response, unknown, GetPageContentParams>({
    mutationFn: async (params: GetPageContentParams) => {
      const response =
        await siteCoreApiP1Instance.post<PageContentApiP1Response>(
          API_ENDPOINTS.SITE_CORE_P1_API,
          {
            PageName: params.PageName,
            MarketName: params.MarketName,
            language: params.language,
            Persona: params.Persona,
          },
        );
      return response?.data ?? null;
    },
    retry: false,
  });
};
